
import { useCallback, useContext, useMemo } from "react";
import { toast } from "react-toastify";
import { GlobalContext } from "../../../Context/GlobalContext";

import useOrdersMain from '../../Services/OrdersMainServices/useOrdersMain';


export default function useOrderActions({ refresh } = {}) {
  const {
    api,
    adminId,
    currentAdmin,
    latitude,
    longitude,
  } = useContext(GlobalContext);

  const {changeAdminOrderStatus}=useOrdersMain();

  const AdminPk = useMemo(() => {
    return adminId || currentAdmin?.pkid || currentAdmin?.adminId || "";
  }, [adminId, currentAdmin]);

  const resolveUserId = (order) => {
    return (
      order?.userid ||
      order?.us_code ||
      ""
    );
  };

const call = useCallback(
  async (status, order, okMsg) => {
    if (!AdminPk) {
      toast.error("Admin ID not found");
      return;
    }

    if (!order?.orderid) {
      toast.error("Order ID missing");
      return;
    }

    const payload = {
      adminId: String(AdminPk),
      userid: resolveUserId(order),
      orderid: String(order.orderid),
      status,
      latitude:
        order?.latitude ??
        latitude ??
        "",
      longitude:
        order?.longitude ??
        longitude ??
        "",
    };

    const result =
      await changeAdminOrderStatus(
        payload
      );

    if (result.success) {
      toast.success(okMsg);
      await refresh?.();
    } else {
      toast.error(result.message);
    }
  },
  [
    AdminPk,
    latitude,
    longitude,
    refresh,
    changeAdminOrderStatus,
  ]
);


  return {
    accept:     (o) => call("accepted",        o, "Order Accepted"),
    prepared:   (o) => call("prepared",        o, "Order Prepared"),
    dispatched: (o) => call("dispatched",      o, "Order Dispatched"),
    delivered:  (o) => call("delivered",       o, "Order Delivered"),
    reject:     (o) => call("rejected",        o, "Order Rejected"),
    mark_paid:  (o) => call("paid",            o, "Marked as Paid"),
  };
}
